import type { LunarEvent, PhenomenonTypeId } from "../types";

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export function formatEventDate(event: LunarEvent): string {
  if (event.year == null) {
    return event.dateText;
  }
  const parts = [String(event.year)];
  if (event.month) {
    parts.push(MONTHS[event.month - 1]);
  }
  if (event.day) {
    parts.push(String(event.day));
  }
  return parts.join(" ");
}

export function formatCoords(lat: number | null, lon: number | null): string {
  if (lat == null || lon == null) {
    return "Unlocated";
  }
  const ns = lat >= 0 ? "N" : "S";
  const ew = lon >= 0 ? "E" : "W";
  return `${Math.abs(lat).toFixed(1)}°${ns} ${Math.abs(lon).toFixed(1)}°${ew}`;
}

export const TYPE_LABELS: Record<PhenomenonTypeId, string> = {
  GASEOUS: "Gaseous / obscuration",
  RED: "Reddish",
  BLUE: "Blue / green / violet",
  BRIGHTENING: "Brightening",
  DARKENING: "Darkening",
  OTHER: "Other",
};
